module.exports = __webpack_public_path__ + "img/瓯海区教育局.aa53be70.png";